export default __webpack_public_path__ + "static/datelabel-dropdown-do-1-dark-5de8f261768aa2c87e751587069f0c4e0bc19f0b3211627f47c9f44ed0ac0bc3.png";